<div id="chartPortfolio" style="width: 100%; height: 300px"></div>
